import { render, staticRenderFns } from "./errorPaper.vue?vue&type=template&id=7a2708e6&scoped=true&"
import script from "./errorPaper.vue?vue&type=script&lang=js&"
export * from "./errorPaper.vue?vue&type=script&lang=js&"
import style0 from "./errorPaper.vue?vue&type=style&index=0&id=7a2708e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2708e6",
  null
  
)

export default component.exports